import React from "react";
import { Box } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./Dashboard/Dashboard";
import Footer from "./Footer/footer";
import ImpressumPage from "./Imprint/imprint";

function App() {
    return (
        <Router>
            <Box
                display="flex"
                flexDirection="column"
                minHeight="100vh"
                sx={{
                    fontFamily: '"Roboto", sans-serif',
                    background: "rgba(227, 242, 253, 0.3)",
                    backgroundImage: 'url(./IMG-20250709-WA0001.jpg)',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                }}
            >
                <Box flex={1} display="flex" alignItems="center" justifyContent="center" px={4}>
                    <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/impressum" element={<ImpressumPage />} />
                    </Routes>
                </Box>

                <Footer />
            </Box>
        </Router>
    );
}

export default App;